export type VoteState = 0 | 1;

export interface VoteOutcome {
  /**
   * The vote (like) state after the user's action:
   * 1 = liked, 0 = not liked.
   */
  nextState: VoteState;
  /**
   * The change that should be applied to the aggregated points count.
   */
  delta: number;
}

/**
 * Resolve the like outcome: toggling between liked (1) and not liked (0).
 */
export function resolveVoteAction(current: VoteState): VoteOutcome {
  if (current === 1) {
    return { nextState: 0, delta: -1 };
  }
  return { nextState: 1, delta: 1 };
}
